import { useState, useContext } from "react";
import ContenedorPrincipal from "../elementos/basicos/ContenedorPrincipal";
import FormCrearCategoriaPublicacion from "../elementos/complejos/FormCrearCategoriaPublicacion";
import FormEditarCategoriaPublicacion from "../elementos/complejos/FormEditarCategoriaPublicacion";
import { UsuarioContext } from "../providers/personaContext";

const GestorCategoriaPublicaciones = ({ crear }) => {

const { persona } = useContext(UsuarioContext);

  return (
    <>
        <ContenedorPrincipal formaform="true"  >

        { crear ?
          <FormCrearCategoriaPublicacion 
          usuarioLogueado={persona}
          />
          :
          <FormEditarCategoriaPublicacion
          usuarioLogueado={persona}
          />
        }
          
        </ContenedorPrincipal>
    </>
  );
}

export default GestorCategoriaPublicaciones;